import React, {useEffect} from 'react';
import {useRouter} from 'next/router';

import {useAppContext} from '../hooks';

/**
 * Component for declarative client-side redirects
 */
export const Redirect = (props) => {
  const router = useRouter();
  useEffect(() => {
    router.replace(props.to);
  }, []);

  return null;
};

/**
 * HOC that redirects to login if user is not logged in
 */
export const withAuthentication = (Component) => (props) => {
  const {currentUser, loading} = useAppContext();
  const router = useRouter();

  if (loading) {
    return null;
  }

  if (!currentUser) {
    return <Redirect to={`/login?returnPath=${router.asPath}`} />;
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} />;
};

/**
 * HOC that checks if the current user is an admin
 */
export const withAdminRole = (Component) => (props) => {
  const {currentUser, loading} = useAppContext();

  if (loading) {
    return null;
  }

  if (currentUser?.role !== 'admin') {
    return <Redirect to="/not-found" />;
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} />;
};
